import { TapeChart, TapeChartWikiService } from '..';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-tape-chart-wiki',
    templateUrl: './tape-chart-wiki.component.html',
    styleUrls: ['./tape-chart-wiki.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class TapeChartWikiComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private tapeChartWikiService: TapeChartWikiService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.tapeChart = data.tapeChart,
			this.statuses = tapeChartWikiService.statuses;
			this.analyzedDate = data.analyzedDate;
	}

	@Input() tapeChart: any;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	rateId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;
	analyzedDate: any;

	validationMessages = {
		'rateId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'rateBucketAdjustmentPct': [],
		'minNightlyRate': [],
		'listPriceAMT': [
			{ type: 'required', message: 'Required' }
		],
		'listPriceAMTExpDate': [],
		'yieldPriceAMT': [],
		'yieldPriceAMTExpDate': [],
		'listPriceAdjustPCT': [],
		'listPriceAdjustPCTExpDate': [{ type: 'required', message: 'Required' }],
		'listPriceAdjustAMT': [],
		'listPriceAdjustAMTExpDate': [],
		'floorRateManagerAMT': [],
		'floorRateManagerAMTExpDate': [],
		'floorRateOwnerAMT': [],
		'floorRateOwnerAMTExpDate': [],
		'ceilingRateManagerAMT': [],
		'ceilingRateManagerAMTExpDate': [],
		'ceilingRateOwnerAMT': [],
		'ceilingRateOwnerAMTExpDate': [],
		'expectedOccupancyPCT': [],
		'expectedOccupancyPCTExpDate': [],
		'maxDiscountPCT': [],
		'maxDiscountPCTExpDate': [],
		'discountLookForwardDays': [],
		'discountLookForwardDaysExpDate': [],
		'discountLookForwardHeadlineDays': [],
		'discountLookForwardHeadlineDaysExpDate': [],
		'discountLookForwardHeadlineMinNightsDays': [],
		'discountLookForwardHeadlineMinNightsDaysExpDate': [],
		'minStayExpectedNTS': [],
		'minStayExpectedNTSExpDate': [],
		'maxStayExpectedNTS': [],
		'maxStayExpectedNTSExpDate': [],
		'avgStayBySeasonNTS': [],
		'avgStayBySeasonNTSExpDate': [],
		'shortTermGapMultiplierPCT': [],
		'shortTermGapMultiplierPCTExpDate': [],
		'shortTermGapPenaltyPCT': [],
		'shortTermGapPenaltyPCTExpDate': [],
		'shortTermGapMinNumNightsRevNTS': [],
		'shortTermGapMinNumNightsRevNTSExpDate': [],
		'longTermGapMultiplierPCT': [],
		'longTermGapMultiplierPCTExpDate': [],
		'longTermGapPenaltyPCT': [],
		'longTermGapPenaltyPCTExpDate': [],
		'longTermGapEmptyMultiplierPCT': [],
		'longTermGapEmptyMultiplierPCTExpDate': [],
		'longTermGapEmptyPenaltyPCT': [],
		'longTermGapEmptyPenaltyPCTExpDate': [],
		'connectingFrontOrBackMultiplierPCT': [],
		'connectingFrontOrBackMultiplierPCTExpDate': [],
		'connectingFrontAndBackMultiplierPCT': [],
		'connectingFrontAndBackMultiplierPCTExpDate': [],
		'lengthOfStayDiscountFactorOffset': [],
		'lengthOfStayDiscountFactorOffsetExpDate': [],
		'createDate': [],
		'lastUpdate': [],
		'analyzedDate': [],
		'propertyId': [],
		'propertyCode': [],
		'rateBucketId': [],
		'description': [],
		'rateSeasonId': [],
		'publicRateDesc': [],
		'type': [],
		'startDate': [],
		'endDate': [],
		'category': [],
		'discountAlorithm': [],
		'reservationId': [],
		'extSystemName': [],
		'extReservationId': [],
		'extConfirmationId': [],
		'extHashId': [],
		'numNightsToNextCheckIn': [],
		'numNightsFromPrevCheckOut': [],
		'qualityScore': [],
		'checkInDateTime': [],
		'checkOutDateTime': [],
		'numNights': [],
		'holdDate': [],
		'quoteDate': [],
		'saleDate': [],
		'closeDate': [],
		'cancelDate': [],
		'reservationType': [],
		'reservationStatus': [],
		'isPaying': [],
		'roomRatePN': [],
		'roomRateTTL': [],
		'lastname': [],
		'firstname': [],
		'email': [],
		'phone': [],
		'numAdults': [],
		'numChildren': [],
		'opsNotes': [],
		'logOutput': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole tapeChart object
		if (this.tapeChart) {
			this.rateId = this.tapeChart.rateId;
			this.fixDates();
			this.form1.patchValue(this.tapeChart);
			//Apply dynamic validation on form load
			// Object.keys(this.form1.controls).forEach(key => {
			// 	this.onFieldValueChange(key, key + 'ExpDate');
			// });
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.rateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.tapeChartWikiService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.tapeChart = res.data.tapeChart;
						this.doAdd.emit(this.tapeChart);
					},
					(err: any) => {
						console.log('tapeChart-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('tapeChart: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.tapeChartWikiService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.tapeChart = res.data.tapeChart;
						this.doUpdate.emit(this.tapeChart);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.tapeChartWikiService.delete(this.tapeChart.rateId)
				.subscribe(
					(res: any) => {
						console.log('tapeChart-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.tapeChart);
					},
					(err: any) => {
						console.log('tapeChart-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	increasePercentage(percentagefield) {
		let updatedValue = this.form1.value[percentagefield] + 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
	decreasePercentage(percentagefield){
		let updatedValue = this.form1.value[percentagefield] - 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}

	updateExpDate(field, days)
	{
		if(days == 'N')
		{
			let date = new Date();
			date.setFullYear(3000, 0, 1);
			date = this.addLocalTimeToDateTime(date);
			this.form1.controls[field].setValue(date);
		}
		else
		{
			let date = new Date();
			date.setDate( date.getDate() + days );
			date = this.addLocalTimeToDateTime(date);
			this.form1.controls[field].setValue(date);
		}
	}

	onFieldValueChange(field, expField)
	{
		if(this.form1.controls[field].value)
		{
			if(this.form1.get(expField))
			{
				this.form1.get(expField).addValidators(Validators.required);
				this.form1.controls[expField].updateValueAndValidity();
			}
		}
		else
		{
			if(this.form1.get(expField))
				{
					this.form1.controls[expField].clearValidators();
					this.form1.controls[expField].updateValueAndValidity();
				}
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			rateId: [this.rateId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			rateBucketAdjustmentPct: [],
			minNightlyRate: [],	
			listPriceAMT: ["", Validators.required],
			listPriceAMTExpDate: [],
			listPriceAdjustPCT: [],
			listPriceAdjustPCTExpDate: [],
			listPriceAdjustAMT: [],
			listPriceAdjustAMTExpDate: [],
			yieldPriceAMT: [],
			yieldPriceAMTExpDate: [],
			floorRateManagerAMT: [],
			floorRateManagerAMTExpDate: [],
			floorRateOwnerAMT: [],
			floorRateOwnerAMTExpDate: [],
			ceilingRateManagerAMT: [],
			ceilingRateManagerAMTExpDate: [],
			ceilingRateOwnerAMT: [],
			ceilingRateOwnerAMTExpDate: [],
			expectedOccupancyPCT: [],
			expectedOccupancyPCTExpDate: [],
			maxDiscountPCT: [],
			maxDiscountPCTExpDate: [],
			discountLookForwardDays: [],
			discountLookForwardDaysExpDate: [],
			discountLookForwardHeadlineDays: [],
			discountLookForwardHeadlineDaysExpDate: [],
			discountLookForwardHeadlineMinNightsDays: [],
			discountLookForwardHeadlineMinNightsDaysExpDate: [],
			minStayExpectedNTS: [],
			minStayExpectedNTSExpDate: [],
			maxStayExpectedNTS: [],
			maxStayExpectedNTSExpDate: [],
			avgStayBySeasonNTS: [],
			avgStayBySeasonNTSExpDate: [],
			shortTermGapMultiplierPCT: [],
			shortTermGapMultiplierPCTExpDate: [],
			shortTermGapPenaltyPCT: [],
			shortTermGapPenaltyPCTExpDate: [],
			shortTermGapMinNumNightsRevNTS: [],
			shortTermGapMinNumNightsRevNTSExpDate: [],
			longTermGapMultiplierPCT: [],
			longTermGapMultiplierPCTExpDate: [],
			longTermGapPenaltyPCT: [],
			longTermGapPenaltyPCTExpDate: [],
			longTermGapEmptyMultiplierPCT: [],
			longTermGapEmptyMultiplierPCTExpDate: [],
			longTermGapEmptyPenaltyPCT: [],
			longTermGapEmptyPenaltyPCTExpDate: [],
			connectingFrontOrBackMultiplierPCT: [],
			connectingFrontOrBackMultiplierPCTExpDate: [],
			connectingFrontAndBackMultiplierPCT: [],
			connectingFrontAndBackMultiplierPCTExpDate: [],
			lengthOfStayDiscountFactorOffset: [],
			lengthOfStayDiscountFactorOffsetExpDate: [],
			createDate: [],
			lastUpdate: [],
			analyzedDate: [],
			propertyId: [],
			propertyCode: [],
			rateBucketId: [],
			description: [],
			rateSeasonId: [],
			publicRateDesc: [],
			type: [],
			startDate: [],
			endDate: [],
			category: [],
			discountAlorithm: [],
			reservationId: [],
			extSystemName: [],
			extReservationId: [],
			extConfirmationId: [],
			extHashId: [],
			numNightsToNextCheckIn: [],
			numNightsFromPrevCheckOut: [],
			qualityScore: [],
			checkInDateTime: [],
			checkOutDateTime: [],
			numNights: [],
			holdDate: [],
			quoteDate: [],
			saleDate: [],
			closeDate: [],
			cancelDate: [],
			reservationType: [],
			reservationStatus: [],
			isPaying: [],
			roomRatePN: [],
			roomRateTTL: [],
			lastname: [],
			firstname: [],
			email: [],
			phone: [],
			numAdults: [],
			numChildren: [],
			opsNotes: [],
			logOutput:[],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.tapeChart.tapeChartDate = moment(this.tapeChart.tapeChartDate).toDate();
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
}
